export default {
  gameBRoute: {
    loadFailed: "Tải thất bại",
    saveSuccess: "Lưu thành công",
    saveFailed: "Lưu thất bại",
    opSuccess: "Thao tác thành công",
    deleteSuccess: "Xóa thành công",
    deleteConfirm: "Xác nhận xóa ánh xạ này? Không thể khôi phục",
    addTitle: "Thêm ánh xạ game tuyến B",
    editTitle: "Sửa ánh xạ game tuyến B",
    selectAPlatformFirst: "Vui lòng chọn nền tảng tuyến A trước",
    aPlatformRequired: "Vui lòng chọn mã nền tảng tuyến A",
    aGameRequired: "Vui lòng chọn mã game tuyến A",
    bPlatformRequired: "Vui lòng chọn mã nền tảng tuyến B",
    bPlatformPh: "Chọn mã nền tảng tuyến B",
    bGameCodeHint: "Có thể để trống (game sảnh; nếu trống sẽ giữ nguyên mã game trên nền tảng B)",
    col: {
      aPlatformCode: "Mã nền tảng tuyến A",
      aGameCode: "Mã game tuyến A",
      bPlatformCode: "Mã nền tảng tuyến B",
      bGameCode: "Mã game tuyến B",
      status: "Trạng thái",
      createTime: "Thời gian tạo",
      action: "Thao tác"
    },
    status: { enabled: "Bật", disabled: "Tắt" },
    btn: { search: "Tìm kiếm", reset: "Đặt lại", add: "Thêm ánh xạ", edit: "Sửa", delete: "Xóa", enable: "Bật", disable: "Tắt" }
  },
  common: {
    button: {
      save: "Lưu",
      back: "Quay lại",
      add: "Thêm",
      edit: "Sửa",
      delete: "Xóa"
    },
    queryFrm: {
      search: "Tìm kiếm",
      reset: "Đặt lại"
    },
    radio: {
      enable: "Bật",
      disable: "Tắt"
    }
  },
  sys: {
    promptMessage: "Thông Báo"
  },
  smsSupplyMgmt: {
    title: "Nhà Cung Cấp Dịch Vụ SMS",
    countryName: "Tên Quốc Gia",
    countryCode: "Mã Quốc Gia",
    smsSupplyName: "Nhà Cung Cấp Dịch Vụ SMS",
    operation: "Thao Tác",
    enable: "Bật",
    disable: "Tắt",
    confirmOperation: "Xác Nhận Thao Tác",
    enableAction: "Bật",
    disableAction: "Tắt",
    confirmEnable: "Bạn có chắc chắn muốn bật nhà cung cấp dịch vụ SMS",
    confirmDisable: "Bạn có chắc chắn muốn tắt nhà cung cấp dịch vụ SMS",
    enableSuccess: "Bật Thành Công",
    disableSuccess: "Tắt Thành Công",
    enableFailed: "Bật Thất Bại",
    disableFailed: "Tắt Thất Bại",
    fetchDataFailed: "Tải Dữ Liệu Thất Bại",
    fetchCountryDataFailed: "Tải Dữ Liệu Quốc Gia Thất Bại",
    loading: "Đang Tải...",
    unknown: "Không Xác Định",
    bottomTip: "Mỗi quốc gia chỉ có một nhà cung cấp dịch vụ SMS",
    paginationTotal: "Tổng {{total}} bản ghi, hiển thị {{start}}-{{end}}"
  },
  gameEntryMgmt: {
    customCategoryManagement: "Quản lý danh mục tùy chỉnh",
    gamePlatformManagement: "Quản lý nền tảng trò chơi",
    gameLine: "Đường trò chơi",
    customGameType: "Loại trò chơi tùy chỉnh",
    systemPlatformCategory: "Danh mục nền tảng hệ thống",
    currency: "Tiền tệ",
    isEnabled: "Đã bật",
    gamePlatformName: "Tên nền tảng trò chơi",
    isMaintenance: "Bảo trì",
    yes: "Có",
    no: "Không",
    operation: "Hoạt động",
    add: "Thêm",
    edit: "Sửa",
    delete: "Xóa",
    enable: "Bật",
    disable: "Tắt",
    maintenance: "Bảo trì",
    refresh: "Làm mới",
    sort: "Sắp xếp",
    selectGameLine: "Vui lòng chọn đường trò chơi",
    selectCurrency: "Vui lòng chọn tiền tệ",
    selectStatus: "Vui lòng chọn trạng thái",
    selectMaintenanceStatus: "Vui lòng chọn trạng thái bảo trì",
    pleaseInputSort: "Vui lòng nhập thứ tự sắp xếp",
    selectCustomGameCategory: "Vui lòng chọn danh mục trò chơi tùy chỉnh",
    selectGamePlatformCategory: "Vui lòng chọn danh mục nền tảng trò chơi",
    operationSuccess: "Thao tác thành công",
    operationFailed: "Thao tác thất bại",
    confirmMessage: "Xác nhận xóa",
    confirmDisable: "Xác nhận tắt",
    confirmEnable: "Xác nhận bật",
    refreshSuccess: "Làm mới thành công",
    dataLoadFailed: "Tải dữ liệu thất bại"
  },
  gameHotMgmt: {
    hotGameList: "Danh sách game hot",
    hotGameLangList: "Danh sách ngôn ngữ game hot",
    displayMethod: "Phương thức hiển thị",
    platformName: "Tên nền tảng",
    gameName: "Tên game",
    gameLine: "Đường dẫn game",
    currency: "Tiền tệ",
    sort: "Sắp xếp",
    manualSort: "Sắp xếp thủ công",
    autoSort: "Sắp xếp tự động",
    isEnabled: "Đã bật",
    yes: "Có",
    no: "Không",
    confirmDisable: "Xác nhận tắt",
    confirmEnable: "Xác nhận bật",
    confirmDelete: "Xác nhận xóa",
    operationSuccess: "Thao tác thành công",
    operationFailed: "Thao tác thất bại",
    dataLoadFailed: "Tải dữ liệu thất bại",
    add: "Thêm",
    edit: "Sửa",
    hotGame: "Game hot",
    language: "Ngôn ngữ",
    entryImage: "Hình ảnh đầu vào",
    uploadEntryImage: "Chưa tải lên hình ảnh đầu vào",
    gamePlatform: "Nền tảng game",
    game: "Game",
    customGameCategory: "Danh mục game tùy chỉnh",
    pleaseSelectDisplayMethod: "Vui lòng chọn phương thức hiển thị",
    pleaseSelectLine: "Vui lòng chọn đường dẫn",
    pleaseSelectCustomGameCategory: "Vui lòng chọn danh mục game tùy chỉnh",
    pleaseSelectGamePlatform: "Vui lòng chọn nền tảng game",
    pleaseSelectGame: "Vui lòng chọn game",
    pleaseInputSort: "Vui lòng nhập thứ tự sắp xếp",
    pleaseSelectLanguage: "Vui lòng chọn ngôn ngữ",
    pleaseSelectHotGame: "Vui lòng chọn game hot",
    pleaseSelectStatus: "Vui lòng chọn trạng thái",
    pleaseInputGameName: "Vui lòng nhập tên game",
    pleaseInputPlatformName: "Vui lòng nhập tên nền tảng",
    setMultiLanguage: "Cài đặt đa ngôn ngữ",
    formValidationFailed: "Xác thực biểu mẫu thất bại",
    addSuccess: "Thêm thành công",
    editSuccess: "Sửa thành công",
    icon: "Biểu tượng",
    status: "Trạng thái",
    enabled: "Đã bật",
    disabled: "Đã tắt",
    pleaseSelectCurrency: "Vui lòng chọn tiền tệ"
  },
  gameListMgmt: {
    gameMainData: "Dữ liệu game chính",
    gameLangData: "Dữ liệu ngôn ngữ",
    platformCategory: "Danh mục nền tảng",
    gamePlatform: "Nền tảng game",
    gameName: "Tên game",
    gameCode: "Mã game",
    sort: "Sắp xếp",
    manualSort: "Sắp xếp thủ công",
    autoSort: "Sắp xếp tự động",
    effectMode: "Phương thức áp dụng",
    isPcSupported: "Hỗ trợ PC",
    isH5Supported: "Hỗ trợ H5",
    displayName: "Tên hiển thị",
    gameEntryIcon: "Biểu tượng đầu vào game",
    batchAdd: "Thêm hàng loạt",
    save: "Lưu",
    back: "Quay lại",
    setMultiLanguage: "Cài đặt đa ngôn ngữ",
    addGameLangData: "Thêm dữ liệu ngôn ngữ game",
    editGameLangData: "Sửa dữ liệu ngôn ngữ game",
    gameSystemName: "Tên hệ thống game",
    language: "Ngôn ngữ",
    confirmDelete: "Xác nhận xóa",
    confirmEnable: "Xác nhận bật",
    confirmDisable: "Xác nhận tắt",
    pleaseSelectCategory: "Vui lòng chọn danh mục",
    pleaseSelectPlatform: "Vui lòng chọn nền tảng",
    pleaseInputGameName: "Vui lòng nhập tên game",
    pleaseInputGameCode: "Vui lòng nhập mã game",
    pleaseInputSort: "Vui lòng nhập thứ tự sắp xếp",
    pleaseSelectPcSupport: "Vui lòng chọn hỗ trợ PC",
    pleaseSelectH5Support: "Vui lòng chọn hỗ trợ H5",
    pleaseInputDisplayName: "Vui lòng nhập tên hiển thị",
    pleaseSelectLanguage: "Vui lòng chọn ngôn ngữ",
    addSuccess: "Thêm thành công",
    editSuccess: "Sửa thành công",
    formValidationFailed: "Xác thực biểu mẫu thất bại",
    dataLoadFailed: "Tải dữ liệu thất bại",
    operationSuccess: "Thao tác thành công",
    operationFailed: "Thao tác thất bại",
    uploadImgStatus: "trạng thái img",
    pleaseSelectIsUploadImg: "tất cả",
    uploadImage: "đã tải lên",
    noUploadImage: "chưa tải lên",
    highRiskGame: "Game rủi ro cao",
    highRiskConfig: "Game rủi ro cao",
    highRiskNo: "Không",
    highRiskYes: "Có",
    highRiskFilterAll: "Tất cả",
    tagImg: "Nhãn game",
    uploadNeedGameInfo: "Vui lòng chọn nền tảng và trò chơi (hoặc nhập mã trò chơi) trước khi tải ảnh lên",
    tagImgHint: "Kích thước 64 × 40 px, tối đa 50 KB",
    notConfigured: "Chưa cấu hình",
    h5Image: "Ảnh H5 (Mobile)",
    pcImage: "Ảnh PC (Ki-ốt / Desktop)",
    h5ImageHint: "Dùng cho client H5 di động",
    pcImageHint: "Dùng cho ki-ốt cửa hàng / PC",
    missingH5: "Thiếu H5 (Mobile)",
    missingPc: "Thiếu PC (Ki-ốt)",
    imgStatusAll: "Tất cả",
    imgStatusH5Only: "Chỉ H5 (thiếu Ki-ốt)",
    imgStatusPcOnly: "Chỉ PC (thiếu Mobile)",
    imgStatusBoth: "Cả hai",
    imgStatusNone: "Không có",
    currency: "Tiền tệ",
    pleaseSelectCurrency: "Vui lòng chọn tiền tệ"
  },
  gamePlatformMgmt: {
    mainData: "Dữ liệu nền tảng chính",
    languageData: "Dữ liệu ngôn ngữ",
    currencyData: "Dữ liệu tiền tệ",
    platformName: "Tên nền tảng",
    platformKey: "Mã nền tảng",
    platformType: "Loại nền tảng",
    platformCategory: "Danh mục nền tảng",
    platform: "Nền tảng",
    platformDisplayName: "Tên hiển thị nền tảng",
    platformDesc: "Mô tả nền tảng",
    platformMaintainNotice: "Thông báo bảo trì",
    platformLogo: "Logo nền tảng",
    platformEntryIcon: "Biểu tượng đầu vào nền tảng",
    language: "Ngôn ngữ",
    currency: "Tiền tệ",
    displayName: "Tên hiển thị",
    addPlatformLangData: "Thêm dữ liệu ngôn ngữ nền tảng",
    setMultiLanguage: "Cài đặt đa ngôn ngữ",
    pleaseInputPlatformName: "Vui lòng nhập tên nền tảng",
    pleaseInputPlatformKey: "Vui lòng nhập mã nền tảng",
    pleaseSelectPlatformType: "Vui lòng chọn loại nền tảng",
    pleaseSelectPlatformCategory: "Vui lòng chọn danh mục nền tảng",
    pleaseSelectPlatform: "Vui lòng chọn nền tảng",
    pleaseInputDisplayName: "Vui lòng nhập tên hiển thị",
    pleaseInputPlatformDesc: "Vui lòng nhập mô tả nền tảng",
    pleaseInputMaintainNotice: "Vui lòng nhập thông báo bảo trì",
    pleaseSelectLanguage: "Vui lòng chọn ngôn ngữ",
    pleaseSelectCurrency: "Vui lòng chọn tiền tệ",
    dataLoadFailed: "Tải dữ liệu thất bại",
    formValidationFailed: "Xác thực biểu mẫu thất bại",
    addSuccess: "Thêm thành công",
    editSuccess: "Sửa thành công",
    operationSuccess: "Thao tác thành công",
    operationFailed: "Thao tác thất bại",
    confirmDeletePlatform: "Xác nhận xóa nền tảng",
    confirmDeletePlatformCurrency: "Xác nhận xóa tiền tệ nền tảng",
    platformCurrency: "Tiền tệ nền tảng",
    column: {
      title: {
        index: "STT",
        gamePlatformName: "Tên nền tảng",
        gamePlatformCode: "Mã nền tảng",
        bRouteCode: "Mã nền tảng tuyến B",
        gameType: "Loại nền tảng",
        desc: "Mô tả",
        gameFullName: "Tên đầy đủ nền tảng",
        gameShowName: "Tên hiển thị",
        action: "Thao tác",
        platformName: "Tên nền tảng",
        platformType: "Loại nền tảng",
        currency: "Tiền tệ"
      }
    }
  },
  // Bản đồ tên tuyến trò chơi (backend chỉ lưu tên tiếng Trung; khóa là tên gốc)
  gameLineName: {
    "美国": "Mỹ",
    "墨西哥": "Mexico",
    "菲律宾": "Philippines"
  },
  // Bản đồ tên thể loại trò chơi (dict 31004/31005 chỉ lưu tên tiếng Trung)
  gameCategoryName: {
    "电子": "Trò chơi điện tử",
    "真人": "Casino trực tuyến",
    "体育": "Thể thao",
    "彩票": "Xổ số",
    "捕鱼": "Bắn cá",
    "棋牌": "Cờ bài",
    "电竞": "Thể thao điện tử",
    "小游戏": "Mini Game",
    "竞猜": "Dự đoán",
    "街机": "Arcade",
    "宾果": "Bingo"
  },
  gamePromotMgmt: {
    mainPromotGamePlatform: "Nền Tảng Game Được Quảng Bá Chính",
    entryImage: "Hình Ảnh Đầu Vào",
    platform: "Nền Tảng",
    gamePlatform: "Nền Tảng Game",
    currency: "Tiền Tệ",
    sort: "Sắp Xếp",
    status: "Trạng Thái",
    enabled: "Đã Bật",
    disabled: "Đã Tắt",
    add: "Thêm",
    edit: "Sửa",
    delete: "Xóa",
    confirmDelete: "Xác Nhận Xóa",
    confirmDisable: "Xác Nhận Tắt",
    confirmEnable: "Xác Nhận Bật",
    addSuccess: "Thêm Thành Công",
    editSuccess: "Sửa Thành Công",
    operationSuccess: "Thao Tác Thành Công",
    operationFailed: "Thao Tác Thất Bại",
    dataLoadFailed: "Tải Dữ Liệu Thất Bại",
    formValidationFailed: "Xác Thực Biểu Mẫu Thất Bại",
    pleaseSelectPlatform: "Vui Lòng Chọn Nền Tảng",
    pleaseSelectGamePlatform: "Vui Lòng Chọn Nền Tảng Game",
    pleaseInputSort: "Vui Lòng Nhập Thứ Tự Sắp Xếp",
    pleaseSelectCurrency: "Vui Lòng Chọn Tiền Tệ",
    pleaseSelectStatus: "Vui Lòng Chọn Trạng Thái",
    column: {
      title: {
        index: "STT",
        platformName: "Tên Nền Tảng",
        gamePlatformName: "Tên Nền Tảng Game",
        gameLine: "Đường Dẫn Game",
        currency: "Tiền Tệ",
        sort: "Sắp Xếp",
        status: "Trạng Thái",
        action: "Thao Tác"
      }
    }
  },
  gameRecMgmt: {
    mainGameList: "Danh Sách Game Chính",
    mainGameLangList: "Danh Sách Ngôn Ngữ Game Chính",
    displayMethod: "Phương Thức Hiển Thị",
    platformName: "Tên Nền Tảng",
    gameName: "Tên Game",
    gameLine: "Đường Dẫn Game",
    currency: "Tiền Tệ",
    sort: "Sắp Xếp",
    manualSort: "Sắp xếp thủ công",
    autoSort: "Sắp xếp tự động",
    status: "Trạng Thái",
    enabled: "Đã Bật",
    disabled: "Đã Tắt",
    add: "Thêm",
    edit: "Sửa",
    delete: "Xóa",
    confirmDelete: "Xác Nhận Xóa",
    confirmDisable: "Xác Nhận Tắt",
    confirmEnable: "Xác Nhận Bật",
    addSuccess: "Thêm Thành Công",
    editSuccess: "Sửa Thành Công",
    operationSuccess: "Thao Tác Thành Công",
    operationFailed: "Thao Tác Thất Bại",
    dataLoadFailed: "Tải Dữ Liệu Thất Bại",
    formValidationFailed: "Xác Thực Biểu Mẫu Thất Bại",
    pleaseSelectPlatform: "Vui Lòng Chọn Nền Tảng",
    pleaseSelectGamePlatform: "Vui Lòng Chọn Nền Tảng Game",
    pleaseInputSort: "Vui Lòng Nhập Thứ Tự Sắp Xếp",
    pleaseSelectCurrency: "Vui Lòng Chọn Tiền Tệ",
    pleaseSelectStatus: "Vui Lòng Chọn Trạng Thái",
    pleaseSelectLanguage: "Vui Lòng Chọn Ngôn Ngữ",
    pleaseSelectGame: "Vui Lòng Chọn Game",
    pleaseSelectCustomGameCategory: "Vui Lòng Chọn Danh Mục Game Tùy Chỉnh",
    pleaseInputPlatformName: "Vui Lòng Nhập Tên Nền Tảng",
    pleaseInputGameName: "Vui Lòng Nhập Tên Game",
    pleaseInputGamePlatformName: "Vui Lòng Nhập Tên Nền Tảng Game",
    pleaseInputGameDefaultName: "Vui Lòng Nhập Tên Game Mặc Định",
    entryImage: "Hình Ảnh Đầu Vào",
    uploadEntryImage: "Chưa Tải Lên Hình Ảnh Đầu Vào",
    gamePlatform: "Nền Tảng Game",
    game: "Game",
    customGameCategory: "Danh Mục Game Tùy Chỉnh",
    language: "Ngôn Ngữ",
    setMultiLanguage: "Cài Đặt Đa Ngôn Ngữ",
    column: {
      title: {
        index: "STT",
        platformName: "Tên Nền Tảng",
        gamePlatformName: "Tên Nền Tảng Game",
        gameName: "Tên Game",
        gameLine: "Đường Dẫn Game",
        currency: "Tiền Tệ",
        sort: "Sắp Xếp",
        status: "Trạng Thái",
        action: "Thao Tác",
        icon: "Biểu Tượng",
        language: "Ngôn Ngữ"
      }
    }
  },
  gameTypeMgmt: {
    editType: "Chỉnh Sửa Loại",
    type: "Loại",
    typeRequired: "Vui Lòng Nhập Loại",
    pleaseInputType: "Vui Lòng Nhập Loại",
    gamePlatform: "Nền Tảng Game",
    pleaseSelectGamePlatform: "Vui Lòng Chọn Nền Tảng Game",
    icon: "Biểu Tượng",
    uploadIconRequired: "Vui Lòng Tải Lên Biểu Tượng",
    menuIcon: "Biểu Tượng Menu",
    updateSuccess: "Cập Nhật Thành Công",
    updateFailed: "Cập Nhật Thất Bại",
    language: "Ngôn Ngữ",
    pleaseSelectLanguage: "Vui Lòng Chọn Ngôn Ngữ",
    yes: "Có",
    no: "Không",
    dataLoadFailed: "Tải Dữ Liệu Thất Bại",
    operationSuccess: "Thao Tác Thành Công",
    operationFailed: "Thao Tác Thất Bại",
    column: {
      title: {
        index: "STT",
        gameGroupName: "Tên Nhóm Game",
        gameStatus: "Trạng Thái Game",
        operateAction: "Thao Tác",
        language: "Ngôn Ngữ",
        icon: "Biểu Tượng",
        menuIcon: "Biểu Tượng Menu"
      }
    }
  },
  gameModuleMgmt: {
    yes: "Có",
    no: "Không",
    pageTitle: "Quản Lý Mô-đun Client",
    line: "Tuyến",
    language: "Ngôn Ngữ",
    selectLine: "Vui lòng chọn tuyến",
    selectLanguage: "Vui lòng chọn ngôn ngữ",
    clientTab: "Tab Client",
    modulesCount: "{{count}} mô-đun",
    moduleListTitle: "Tab · Danh Sách Mô-đun (Tổng {{count}} mô-đun)",
    selectTabHint: "Vui lòng chọn tuyến, ngôn ngữ rồi chọn Tab",
    systemLocked: "🔒 Mô-đun Hệ Thống (Không thể cấu hình)",
    jumpToSource: "⚙ Đi Tới Menu Nguồn",
    addModule: "+ Thêm Mô-đun",
    editModule: "Chỉnh Sửa Mô-đun",
    configGame: "⚙ Cấu Hình Game",
    back: "Quay Lại",
    confirmDelete: "Xác nhận xóa mô-đun này?",
    addSuccess: "Thêm thành công",
    editSuccess: "Cập nhật thành công",
    deleteSuccess: "Xóa thành công",
    platformOrTabRequired: "Vui lòng chọn tuyến và Tab trước",
    manualSort: "Sắp xếp thủ công",
    autoSort: "Sắp xếp tự động",
    autoSortRule: "Quy tắc sắp xếp tự động",
    resetDate: "Ngày đặt lại",
    resetTime: "Giờ đặt lại",
    daily: "Hàng ngày",
    weekly: "Hàng tuần",
    column: {
      sort: "Thứ Tự",
      autoSortRule: "Quy tắc sắp xếp tự động",
      icon: "Icon",
      label: "Nhãn",
      name: "Tên Mô-đun",
      isSystem: "Hệ Thống",
      status: "Trạng Thái",
      action: "Thao Tác"
    },
    add: { title: "Thêm Mô-đun" },
    edit: { title: "Chỉnh Sửa Mô-đun" },
    form: {
      sort: "Thứ Tự",
      sortRequired: "Vui lòng nhập thứ tự",
      sortMustBeInteger: "Thứ tự phải là số nguyên",
      moduleName: "Tên Mô-đun",
      moduleNameRequired: "Vui lòng nhập tên mô-đun",
      iconUrl: "Icon Mô-đun",
      iconUrlRequired: "Vui lòng tải lên icon",
      gameLabelUrl: "Nhãn Game",
      remark: "Ghi Chú",
      remarkPlaceholder: "Quy tắc mô-đun, nguồn dữ liệu, ghi chú vận hành (chỉ hiển thị backend)",
      langSelect: "Ngôn Ngữ",
      langSelectRequired: "Vui lòng chọn ngôn ngữ",
      langHint: "⚙ Tên / Icon / Nhãn / Ghi chú duy trì độc lập theo từng ngôn ngữ",
      displayRows: "Số dòng hiển thị",
      displayRowsRequired: "Vui lòng chọn số dòng hiển thị",
      displayRows1: "1*3 (1 dòng / 3 trò chơi)",
      displayRows2: "2*3 (2 dòng / 6 trò chơi)",
      displayRows3: "3*3 (3 dòng / 9 trò chơi)",
      displayRowsKiosk1: "1*7 (1 dòng / 7 trò chơi)",
      displayRowsKiosk2: "2*7 (2 dòng / 14 trò chơi)",
      displayRowsKiosk3: "3*7 (3 dòng / 21 trò chơi)"
    },
    gameConfig: {
      module: "Mô-đun",
      attached: "Đã gắn",
      attachedCount: "{{count}} game",
      addGame: "Thêm",
      batchRemove: "Xóa Hàng Loạt",
      remove: "Xóa",
      confirmRemove: "Xác nhận gỡ game này khỏi mô-đun?",
      confirmBatchRemove: "Xác nhận gỡ {{count}} game đã chọn khỏi mô-đun?",
      removeSuccess: "Đã gỡ",
      selectAtLeastOne: "Vui lòng chọn ít nhất một game"
    },
    gameAdd: {
      title: "Chọn game từ \"Cài đặt Sub-game\" gắn vào mô-đun",
      index: "STT",
      gameType: "Phân Loại Nền Tảng",
      gamePlatform: "Nền Tảng Game",
      gameName: "Tên Game",
      gameNamePlaceholder: "Nhập tên game",
      selectGameType: "Chọn phân loại",
      selectGamePlatform: "Chọn nền tảng game",
      platformRequired: "Vui lòng chọn nền tảng game trước",
      selectAtLeastOne: "Vui lòng chọn ít nhất một game",
      addSuccess: "Thêm thành công"
    }
  },
  desktopGameModuleMgmt: {
    pageTitle: "Quản lý Mô-đun Ki-ốt",
    desktopTab: "Tab Ki-ốt",
    copyFromClient: "Sao chép từ Client",
    copyFromClientHint: "Mô-đun ki-ốt lưu độc lập với mô-đun client. Có thể sao chép tất cả các nhóm từ cấu hình client làm khởi điểm.",
    copyFromClientConfirm: "Xác nhận sao chép tất cả các nhóm từ client? Mô-đun hệ thống được khử trùng lặp theo mã; mô-đun tùy chỉnh chỉ sao chép cho nhóm hiện đang trống. Không ghi đè dữ liệu hiện có.",
    copyFromClientResult: "Đã sao chép {{count}} mô-đun",
    selectLineFirst: "Vui lòng chọn line trước"
  }
};
